import { Box, Switch } from '@mui/material';
import { useTranslation } from 'react-i18next';

import {
  AllowSkipBox,
  AllowSkipDescription,
  AllowSkipTitle,
} from '../TriggerSection/styled';

interface AllowSkipToggleProps {
  allowSkipDialog: boolean;
  onAllowSkipDialogChange: (allow: boolean) => void;
}

const AllowSkipToggle = ({
  allowSkipDialog,
  onAllowSkipDialogChange,
}: AllowSkipToggleProps) => {
  const { t } = useTranslation('common');

  return (
    <AllowSkipBox>
      <Switch
        checked={allowSkipDialog}
        onChange={(e) => onAllowSkipDialogChange(e.target.checked)}
        sx={{
          '& .MuiSwitch-switchBase.Mui-checked': {
            color: 'var(--am-accent-text)',
          },
          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
            backgroundColor: 'var(--am-accent-text)',
          },
        }}
      />
      <Box>
        <AllowSkipTitle>
          {t('assistant.scriptDialog.allowSkipDialog')}
        </AllowSkipTitle>
        <AllowSkipDescription>
          {t('assistant.scriptDialog.allowSkipDialogDesc')}
        </AllowSkipDescription>
      </Box>
    </AllowSkipBox>
  );
};

export default AllowSkipToggle;
